const CHOICE_KEY = 'wtfnetflix-analytics-choice-v2';
const CAMPAIGN = /^[a-zA-Z0-9._~-]{1,64}$/;
// randomUUID is unavailable on plain HTTP LAN addresses. These IDs only
// deduplicate anonymous analytics events; they are not security tokens.
function uuid() {
    if (typeof window.crypto?.randomUUID === 'function') return window.crypto.randomUUID();
    const bytes = new Uint8Array(16);
    if (typeof window.crypto?.getRandomValues === 'function') window.crypto.getRandomValues(bytes);
    else for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
let sessionId;
const campaign = Object.fromEntries(['source','medium','campaign'].map(key => {
    const value = new URLSearchParams(window.location.search).get(`utm_${key}`);
    return [key, value && CAMPAIGN.test(value) ? value : null];
}));
export function getAnalyticsChoice() {
    try { return localStorage.getItem(CHOICE_KEY); } catch { return null; }
}
export function setAnalyticsChoice(choice) {
    try { localStorage.setItem(CHOICE_KEY, choice); } catch {}
    window.wtfAnalytics?.setChoice(choice);
}
export function newRequestId() { return uuid(); }
export function track(name, { requestId, titleKey } = {}) {
    if (getAnalyticsChoice() !== 'yes') return;
    window.wtfAnalytics?.track(name);
    if (!sessionId) sessionId = uuid();
    const body = JSON.stringify({ name, sessionId, requestId: requestId || newRequestId(), titleKey: titleKey || null, ...campaign });
    fetch('/api/analytics/event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
}
